import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import MessageStore from '../stores/messageStore';

@observer
export default class Message extends Component {
  render() {
    const { messageStore } = this.props;
    const { messages, showMessage } = messageStore;

    return (
      <div>
        {messages.map(messageObj => (
          <Alert key={`${messageObj.message}id`} color={messageObj.messageType} isOpen={showMessage}>
            <span
              className={messageObj.messageType === 'success' ? 'icon icon-ok-circle' : 'icon icon-attention-circle'}
            />
            <span> {messageObj.message} </span>
          </Alert>
        ))}
      </div>
    );
  }
}

Message.propTypes = {
  messageStore: PropTypes.oneOf([MessageStore]),
};
